import classNames from "classnames"
import React, { useMemo } from "react"

import { Analytics } from "@bounce/analytics"
import { useTranslation } from "@bounce/i18n"
import { LinkList } from "@bounce/web-components"

import { useSectionViewed } from "../../../hooks/useSectionViewed"
import { InteractionEvents } from "../../../libs/analytics/events"
import type { CityScreenProps } from "../../../screens/LuggageStorage/CityScreen/CityScreen"

export type CityListProps = {
  cities?: CityScreenProps["nearbyCities"]
  className?: string
}

export const CityList = ({ cities, className }: CityListProps) => {
  const { t } = useTranslation()
  const { sectionRef } = useSectionViewed({ name: "CityList" })
  const citiesLinks = useMemo(
    () =>
      cities?.map(({ id, translatedName, url }) => ({
        href: url,
        name: translatedName,
        title: t("cmp.generic.poiList.luggageStorageInNearbyCity", "Luggage Storage in {{CITY_NAME}}", {
          cityName: translatedName,
        }),
        onClick: () =>
          Analytics.track(InteractionEvents.InternalLinkPressed, {
            name: "CityList/NearbyCityLink",
            cityId: id,
            cityName: translatedName,
          }),
      })),
    [cities, t],
  )

  if (!citiesLinks?.length) {
    return <div className="pb-section" />
  }

  return (
    <LinkList
      className={classNames("mx-auto w-full max-w-screen-xl px-6", className)}
      label={t("cmp.generic.poiList.nearbyCitiesLabel", "Store your luggage in a nearby city")}
      links={citiesLinks}
      sectionRef={sectionRef}
      as="nav"
    />
  )
}
